import { atom } from 'jotai';

export type AuthData = {
  id: string;
  email: string;
  name: string;
  customerId: string;
  masterCustomerId: string;
  cmpOrgSsoId: string;
  productScope: string;
  productId: string;
  productSku: string;
  operations: Array<{
    name: string;
    allowed: boolean;
  }>;
  connectedOpalInstanceId: string;
  accessToken: string;
  instanceId: string;
  hostedRegion?: string;
  userPreferences?: { fontSize: 'comfort' | 'default' };
};

export type AuthStrategy = 'bearer' | 'cookie';

export type OpalAuthOptions = { strategy?: AuthStrategy };

export type OpalAuth = {
  create: (
    instanceId: string,
    initialAccessToken?: string,
    getAccessToken?: () => Promise<string | null>,
    initialAuthData?: AuthData,
    options?: OpalAuthOptions
  ) => OpalAuth;
  initAuth: () => Promise<void>;
  getAuthData: () => AuthData | undefined;
  getStrategy?: () => AuthStrategy;
  logout: () => Promise<void>;
};

export const opalAuthAtom = atom<OpalAuth>();
